module.exports = __webpack_public_path__ + "static/media/Map.a15a911a.svg";